import util from '@bmp-vue/core/api/util'
const controller = 'Oficina'
export default Object.assign({}, util.GetCrud(controller, ['none']), {
  TipoAssinanteEnum: {
    Emitente: 1,
    Avalista: 3,
    Conjuge: 4,
    Outros: 9
  },
})
